import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as ENV } from './../../../environments/environment';
import * as apiUrl from '../constants/api-urls';
import { Observable, Subject, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScenerioService {
  api_url = `${ENV.API_ENDPOINT}`;
  price_hierarchy: any = new Subject()

  constructor(private http:HttpClient) { }

  getScenerioList(params:any){
    let url = this.api_url + apiUrl.scenario.getScenerioList
    return this.http.post(url,params)
  }
 
  getApprovalScenarioList(params:any){
    let url = this.api_url + apiUrl.scenario.getApprovalScenerioList
    return this.http.post(url,params)
  }
 
  getApprovalScenarioPriceBandDetails(params:any){
    let url = this.api_url + apiUrl.scenario.getApprovedScenariopriceBand;
    return this.http.post(url,params)
  }
 
  getApprovalScenarioSKUDetails(params:any){
    let url = this.api_url + apiUrl.scenario.getApprovedScenarioskuDetails;
    return this.http.post(url,params)
  }
 
  getApprovalScenarioSKUDetailsCount(params:any){
    let url = this.api_url + apiUrl.scenario.getApprovedScenarioskuDetailsCount;
    return this.http.post(url,params)
  }

  getStatusDetails(){
    let url = this.api_url + apiUrl.scenario.statuslist
    return this.http.get(url)
  }

  deleteScenario(payload: any){
    let url = this.api_url + apiUrl.scenario.scenarioDelete;
    return this.http.post(url, payload)
  }

  getScenarioEstimatedImpact(paylaod: any){
    let url = this.api_url + apiUrl.scenario.estimatedImpact;
    return this.http.post(url, paylaod);
  }

  getScenarioEstimatedImpactPriceTier(payload: any){
    let url = this.api_url + apiUrl.scenario.estimatedImpactPriceBand;
    return this.http.post(url, payload);
  }
  
  getScenarioOriginalImpact(paylaod: any){
    let url = this.api_url + apiUrl.scenario.originalImpact;
    return this.http.post(url, paylaod);
  }
  
  getScenarioOriginalImpactPriceTier(payload: any){
    let url = this.api_url + apiUrl.scenario.originalImpactPriceBand;
    return this.http.post(url, payload);
  }
  
  getScenarioHeaderDetails(payload: any){
    let url = this.api_url + apiUrl.scenario.scenarioHeader;
    return this.http.post(url, payload);
  }

  getCreateScenarioHeaderDetails(payload: any){
    let url = this.api_url + apiUrl.scenario.createScenarioHeader;
    return this.http.post(url, payload);
  }

  getScenarioSKUOriginalImpact(payload: any){
    let url = this.api_url + apiUrl.scenario.originalImpactPriceBandOverall;
    return this.http.post(url, payload);
  }

  getScenarioSKUEstimatedImpact(payload: any){
    let url = this.api_url + apiUrl.scenario.estimatedImpactPriceBandOverall;
    return this.http.post(url, payload);
  }

  getTempScenarioSKUEstimatedImpact(payload: any){
    let url = this.api_url + apiUrl.scenario.tempAPis.estimatedImpactPriceBandOverall;
    return this.http.post(url, payload);
  }

  getCreatorDetails(){
    let url = this.api_url + apiUrl.scenario.creatorData;
    return this.http.get(url);
  }

  private handleError<T>(result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

  getScenarioPriceTierData(payload:any){
    let url = this.api_url + apiUrl.scenario.priceTier;
    return this.http.post(url, payload)
  }
  
  getScenarioPriceTierDataWithRegionId(payload:any){
    let url = this.api_url + apiUrl.scenario.priceTier;
    return this.http.post(url, payload)
  }

  getSKUDetails(payload:any){
    let url = this.api_url + apiUrl.scenario.skuDetails;
    return this.http.post(url, payload)
  }

  getTempSKUDetails(payload:any){
    let url = this.api_url + apiUrl.scenario.tempAPis.skuDetails;
    return this.http.post(url, payload)
  }
  
  getSKUDetailsCount(payload:any) {
    let url = this.api_url + apiUrl.scenario.skuDetailsCount;
    return this.http.post(url, payload)
  }

  getTempSKUDetailsCount(payload:any) {
    let url = this.api_url + apiUrl.scenario.tempAPis.skuDetailsCount;
    return this.http.post(url, payload)
  }

  getSKUPriceTierDetails(payload: any){

    let url = this.api_url + apiUrl.scenario.skuDetails;
    return this.http.post(url, payload)
  }


  createSKUDetails(payload:any){
    let url = this.api_url + apiUrl.scenario.createSkuDetails 
    return this.http.post(url,payload)
  }
  getScenarioPriceTierDropDownValues(payload:any){
    let url = this.api_url + apiUrl.scenario.tempAPis.tempPriceBand;
    return this.http.post(url, payload);
  }
  getCategoryData(data:any){
    let url = this.api_url + apiUrl.scenario.category;
    return this.http.post(url,data)
  }

  recalculateImpact(paylaod:any){
    let url = this.api_url + apiUrl.scenario.recalculateImpact;
    return this.http.post(url,paylaod)
  }

  submitForApproval(paylaod:any){
    let url = this.api_url + apiUrl.scenario.submitForApproval;
    return this.http.post(url,paylaod)
  }

  submitForRejected(paylaod:any){
    let url = this.api_url + apiUrl.scenario.submitForRejected;
    return this.http.post(url,paylaod)
  }

  submitForApproved(paylaod:any){
    let url = this.api_url + apiUrl.scenario.submitForApproved;
    return this.http.post(url,paylaod)
  }

  createScenario(payload:any){
    let url = this.api_url + apiUrl.scenario.createScenario;
    return this.http.post(url,payload)
  }
  downloadScenario (payload:any){
    let url = this.api_url + apiUrl.scenario.download;
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    return this.http.post(url, payload, httpOptions);
  }

  uploadScenario (formData:FormData){
    let url = this.api_url + apiUrl.scenario.upload;
    return this.http.post(url,formData)
  }
  
  /** to get chart data */
  getGraphData(payload: any) {
    let  url = this.api_url + apiUrl.recommendation.graphData;
    return this.http.post(url, payload);
  }

  getPriceHierarchyData(payload:any){
    let  url = this.api_url + apiUrl.scenario.priceHierarchy;
    return this.http.post(url, payload);
  }

  getOverrideProducts(payload:any){
    let  url = this.api_url + apiUrl.scenario.override;
    return this.http.post(url, payload);
  }

  downloadViolation (payload:any){
    let url = this.api_url + apiUrl.scenario.download_violation;
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    return this.http.post(url, payload, httpOptions);
  }

  downloadRuleService(payload:any){
    let url = this.api_url + apiUrl.price_recommender.downloadConstraintRules;
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    return this.http.post(url, payload, httpOptions);
  }

    /** get list of constraint for popup */
    getConstraintList(payload: any) {
      let url = this.api_url + apiUrl.scenario.constraintList;
      return this.http.post(url, payload);
    }

    /*get scenario exported data as excel file*/
    scenarioExportService(payload:any){
      let url = this.api_url + apiUrl.scenario.exportScenario;
      const httpOptions = {
        observe: 'response' as 'body',
        responseType: 'blob' as 'json',
      };
      return this.http.post<Blob>(url, payload, httpOptions);
    }

  /*get scenario exported data as excel file*/
  priceRangeExportService(payload:any){
    let url = this.api_url + apiUrl.recommendation.exportScenario;
    const httpOptions = {
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<Blob>(url, payload, httpOptions);
}

    getEstimatedDurationDropdown(payload:any){
      let url = this.api_url + apiUrl.scenario.estimatedDurationDropdown;
      return this.http.post(url, payload);
    }

    getImpactCategoryDropdown(payload:any){
      let url = this.api_url + apiUrl.scenario.categoryImpactDropdown;
      return this.http.post(url, payload);
    }

    getTempL1CategoryDropdownDetails(payload:any){
      let url = this.api_url + apiUrl.scenario.tempAPis.l1Category;
      return this.http.post(url, payload);
    }

    getTempL2CategoryDropdownDetails(payload:any){
      let url = this.api_url + apiUrl.scenario.tempAPis.l2Category;
      return this.http.post(url, payload);
    }

    getTempSubCategoryDropdownDetails(payload:any){
      let url = this.api_url + apiUrl.scenario.tempAPis.subCategory;
      return this.http.post(url, payload);
    }

    getTempItemDropdownDetails(payload:any){
      let url = this.api_url + apiUrl.scenario.tempAPis.tempItemDetails;
      return this.http.post(url, payload);
    }

    getL1CategoryDropdownDetails(payload:any){
      let url = this.api_url + apiUrl.scenario.l1Category;
      return this.http.post(url, payload);
    }

    getL2CategoryDropdownDetails(payload:any){
      let url = this.api_url + apiUrl.scenario.l2Category;
      return this.http.post(url, payload);
    }

    getSubCategoryDropdownDetails(payload:any){
      let url = this.api_url + apiUrl.scenario.subCategory;
      return this.http.post(url, payload);
    }

    getItemDropdownDetails(payload:any){
      let url = this.api_url + apiUrl.scenario.ItemDetails;
      return this.http.post(url, payload);
    }

    getScenarioFilters(){
      let url = this.api_url + apiUrl.scenario.scenarioFilters;
      return this.http.get(url);
    }
}
